import { MutationTree } from "vuex";
import { INewsState } from "@/core/interfaces/news.interface";

const mutations: MutationTree<INewsState> = {
  setNewsLoading(state, isLoading) {
    state.isNewsLoading = isLoading;
  },
  setNews(state, newsData) {
    state.news = newsData;
  },
};

export default mutations;
